// 2017年年终投票出来的直播头衔
export const Cup2018 = {
  data () {
    return {
      isA: false,
      isB: false,
      isC: false,
      isD: false,
      isE: false,
      isG: false
    }
  },
  mounted () {
    let str = this.data.teacherTags || this.data.userTags
    let x = String(str).split('')
    if (x.indexOf('1') > -1) {
      this.isA = true
    } else if (x.indexOf('2') > -1) {
      this.isB = true
    } else if (x.indexOf('3') > -1) {
      this.isC = true
    } else if (x.indexOf('4') > -1) {
      this.isD = true
    }
    this.isE = x.indexOf('5') > -1
    this.isG = x.indexOf('6') > -1
  }
}
